// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"490":"de8b387e","701":"6a0d30a3","952":"14b50b1a"}[chunkId] + ".chunk.css";
};